/* eslint-disable no-use-before-define */
/* eslint-disable @typescript-eslint/no-use-before-define */
/* eslint-disable no-unused-expressions */
/* eslint-disable @typescript-eslint/no-explicit-any */
import {
    DatePicker,
    LayoutContent,
    changeBreadCrumbAction,
    Panel,
    Language,
    Dropdown,
    Label,
    Form,
    required,
    TextField,
    SearchComboBox,
    SearchCriteria,
    MessageBar,
    Section,
    SectionSize,
} from '@eta/components';
import {
    CommandBar,
    DefaultButton,
    ICommandBarItemProps,
    IDropdownOption,
    IIconProps,
    ISelectableOption,
    MessageBarType,
    PrimaryButton,
    TooltipHost,
} from 'office-ui-fabric-react';
import React, { FC, useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { connect, ConnectedProps } from 'react-redux';
import { useHistory, useLocation, useParams } from 'react-router-dom';
import {
    SuccessMessageDuration,
    UIHelpers,
    ReportIssue,
} from '../../../helpers/UIHelpers';
import './Devices.scss';
import { StatusDialog } from './StatusDialog';
import { ServiceCreator } from '../../../Services/ClientProxy/ServiceFactory';
import { ServiceCreator as CommonServiceCreator } from '../../../../src/common/Service/client';
import { ReduxState } from '../../../common/reducers';
import {
    ClientSecretModel,
    CurrentDeviceDto,
    DeviceStatusDto,
    EditCurrentDeviceDto,
    ModelListItemDto,
    ModelStatus,
    TaxpayerDeviceDetailDto,
    VendorStatus,
} from '../../../Services/POS/PosService';
import { Languages, POSStatus } from '../../../common/config/constants';
import RegenerateDeviceSecrets from './RegenerateDeviceSecrets';
import { loadTaxpayerProfile } from '../../Redux/Actions';
import { authService } from '../../../Security/Security';
import { isEmptyText } from '../../../helpers/utils';
import { GetTaxpayerBranchLightDto } from '../../../common/Service/proxy';
import { ClaimsHelper } from '../../../helpers/ClaimsHelper';
import RetireDialog from './RetireDialog';

const cancelIcon: IIconProps = { iconName: 'Cancel' };
const saveIcon: IIconProps = { iconName: 'Save' };

export interface Params {
    id: string;
}

export interface Route {
    inEditMode: boolean;
}

const mapStateToProps = (state: ReduxState) => ({
    currentLanguage: state.reduxlanguage.language,
    currentTaxpayerProfile: state.taxpayerProfile.currentTaxpayerProfile,
});

const mapDispatchToProps = {
    dispatchChangeBreadcrumb: changeBreadCrumbAction,
    dispatchLoadTaxpayerProfile: loadTaxpayerProfile,
};

const connector = connect(mapStateToProps, mapDispatchToProps);
type AddDeviceProps = ConnectedProps<typeof connector>;

const DeviceDetails: FC<AddDeviceProps> = (props: AddDeviceProps) => {
    const predefinedModel = (window as any).REACT_APP_PredefinedMobileModel;
    const {
        currentLanguage: propsCurrentLanguage,
        currentTaxpayerProfile: propscurrentTaxpayerProfile,
        dispatchChangeBreadcrumb,
    } = props;
    const { t } = useTranslation(['pos', 'common']);
    const { id } = useParams<Params>();
    const location = useLocation<Route>();
    const inEditMode = location?.state?.inEditMode;
    const [currentMode, setCurrentMode] = useState<DeviceDetailsType>();
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [showChangeStatusMessage, setShowChangeStatusMessage] =
        useState<boolean>(false);
    const [device, setDevice] = useState<TaxpayerDeviceDetailDto>();
    const [exceptionMessage, setExceptionMessage] = useState<
        string | undefined
    >();
    const [modelCurrentPage, setModelCurrentPage] = useState<number>();
    const [modelErrorMessage, setModelErrorMessage] = useState<string>('');
    const [modelList, setModelList] = React.useState<ModelListItemDto[]>([]);
    const [modelItem, setModelItem] = useState<ModelListItemDto>();
    const [models, setModels] = useState<ModelListItemDto[]>();
    const [modelMetadata, setModelMetadata] = useState<{
        totalPages?: number;
        totalCount?: number;
    }>();
    const [currentLanguage, setCurrentLanguage] =
        useState<Language>(propsCurrentLanguage);
    const [showMessageSuccess, setShowMessageSuccess] =
        useState<boolean>(false);
    const [taxpayerBranchesList, setTaxpayerBranchesList] =
        useState<IDropdownOption[]>();
    const [taxpayerBranches, setTaxpayerBranches] =
        useState<GetTaxpayerBranchLightDto[]>();
    const [showDeactivateDialog, setShowDeactivateDialog] =
        useState<boolean>(false);
    const [showRetireDialog, setShowRetireDialog] = useState<boolean>(false);
    const [showRegenerateDialog, setShowRegenerateDialog] =
        useState<boolean>(false);
    const history = useHistory();
    const [isEditable, setIsEditable] = useState<boolean>(false);
    const [noSubmitReason, setNoSubmitReason] = useState<string | undefined>(
        undefined
    );
    const [readyForSubmit, setReadyForSubmit] = useState<boolean>(false);
    const [registerAndNew, setRegisterAndNew] = useState<boolean>(false);
    const [permDate, setPermDate] = useState<Date>();
    const [clientSecret, setClientSecret] = useState<ClientSecretModel>();
    const [isActive, setIsActive] = useState<boolean>();
    const form = useRef(new Form({}));
    const [isFormValid, setIsFormValid] = useState<boolean>(
        form.current.isValid
    );
    const [isActiveBranch, setIsActiveBranch] = useState<boolean>(true);
    const [branchErrorMessage, setBranchErrorMessage] = useState<string>('');
    const [RetiringWindow, setRetiringWindow] = useState<number | undefined>();
    form.current.onValidityChanged = (isValid) => setIsFormValid(isValid);
    const PredefinedMobileModel = (window as any)
        .REACT_APP_PredefinedMobileModel;
    type DeviceDetailsType = 'new' | 'view';
    const today = new Date();

    const getCommandBar = () => {
        const canSubmitRerport = ClaimsHelper.canSubmitComplaints();
        const RetireOrPremRetire =
            device?.statusId === POSStatus.Retired ||
            device?.statusId === POSStatus.Retiring;
        const actions: ICommandBarItemProps[] = [
            {
                key: !isActive ? 'Reactivate' : 'Deactivate',
                disabled:
                    isEditable ||
                    device?.isStatusUpdatedByAdmin === true ||
                    RetireOrPremRetire,
                onRender: () => (
                    <TooltipHost
                        content={
                            device?.isStatusUpdatedByAdmin === true
                                ? t('DeactivatePOSTooltip')
                                : ''
                        }
                        calloutProps={{ calloutMaxWidth: 200 }}
                        className="POSDevice_DeactivateButton_Tooltip"
                    >
                        <DefaultButton
                            className="commandAction deactivateButton"
                            disabled={
                                isEditable ||
                                device?.isStatusUpdatedByAdmin === true ||
                                RetireOrPremRetire
                            }
                            onClick={() => {
                                setShowDeactivateDialog(true);
                            }}
                            iconProps={{
                                iconName: !isActive
                                    ? 'PlayResume'
                                    : 'StatusCircleBlock',
                            }}
                        >
                            {t(!isActive ? 'reactivate' : 'deactivate')}
                        </DefaultButton>
                    </TooltipHost>
                ),
            },
            {
                key: 'Regenerate',
                text: t('reGenerate'),
                iconProps: { iconName: 'Redo' },
                disabled:
                    isEditable ||
                    device?.modelName === PredefinedMobileModel ||
                    RetireOrPremRetire,
                onClick: () => {
                    setShowRegenerateDialog(true);
                },
            },
            {
                key: 'Edit',
                text: t('edit'),
                iconProps: { iconName: 'Edit' },
                disabled:
                    isEditable ||
                    device?.modelName === PredefinedMobileModel ||
                    RetireOrPremRetire,
                onClick: () => {
                    setIsEditable(true);
                },
            },
        ];
        if (canSubmitRerport) {
            const reportItem = {
                key: 'ReportIssue',
                name: t('ReportIssue'),
                disabled: RetireOrPremRetire,
                iconProps: { iconName: 'FileComment' },
                onClick: () => {
                    ReportIssue(device?.id);
                },
            };
            actions.unshift(reportItem);
        }

        const RetireItem = {
            key: 'Retire',
            name: t(
                device?.statusId === POSStatus.Retiring ||
                    device?.statusId === POSStatus.Retired
                    ? 'revert'
                    : 'Retire'
            ),
            iconProps: {
                iconName:
                    device?.statusId === POSStatus.Retiring ||
                    device?.statusId === POSStatus.Retired
                        ? 'EmptyRecycleBin'
                        : 'RecycleBin',
            },
            disabled:
                device?.statusId === POSStatus.Retired ||
                device?.modelName === PredefinedMobileModel,
            onClick: () => {
                setShowRetireDialog(true);
            },
        };
        actions.unshift(RetireItem);
        return actions;
    };

    const DeviceStatusEnum: IDropdownOption[] = [
        { key: '0', text: t('Pending'), data: 'pending' },
        { key: '1', text: t('Inactive'), data: 'inactive' },
        { key: '2', text: t('Active'), data: 'active' },
        { key: '3', text: t('Retiring'), data: 'retiring' },
        { key: '4', text: t('Retired'), data: 'retired' },
    ];

    type ModelCritieriaName = 'Model' | 'Vendor';

    const setPermenantDate = (dev?: TaxpayerDeviceDetailDto) => {
        setPermDate(undefined);
        if (dev?.statusId === POSStatus.Retiring && dev?.retiredDate) {
            const copyOfDate = new Date(dev?.retiredDate.valueOf());
            const hours = copyOfDate?.getHours() + (RetiringWindow ?? 0);
            copyOfDate.setHours(hours);
            setPermDate(copyOfDate);
        } else if (dev?.statusId === POSStatus.Retired) {
            setPermDate(dev.permRetiredDate);
        }
    };

    useEffect(() => {
        if (RetiringWindow) {
            setPermenantDate(device);
        }
    }, [RetiringWindow]);
    const setSubmitReason = (
        taxpayerDevice: TaxpayerDeviceDetailDto | undefined,
        branchActive: boolean | undefined
    ): void => {
        if (!taxpayerDevice) return;

        const ready = UIHelpers.getNotSubmitReason(
            taxpayerDevice,
            taxpayerDevice.statusId === POSStatus.Active
        );
        const RetireOrPremRetire =
            taxpayerDevice.statusId === POSStatus.Retired ||
            taxpayerDevice.statusId === POSStatus.Retiring;

        if (ready.canSubmit && !RetireOrPremRetire && branchActive) {
            setReadyForSubmit(true);
            setNoSubmitReason(`${t('yes')}`);
        } else {
            const reason = !branchActive
                ? t('branchIsNotActive')
                : t(ready.noSubmitReason ?? '');

            setNoSubmitReason(`${t('no')} | ${reason}`);
        }
    };

    const getDeviceDetails = async () => {
        try {
            const client = ServiceCreator.getPosManagementPublicClient();
            const deviceId = Number(id);
            const response = await client.getDeviceDetails(deviceId);
            const checkIsActiveBranch = UIHelpers.checkBranchActivity(
                response.branchStartDate,
                response.branchCeaseDate
            );
            setDevice(response);
            setIsActiveBranch(checkIsActiveBranch);
            setModelItem(
                new ModelListItemDto({
                    id: response?.modelId,
                    name: response.modelName,
                    vendorName: response.vendorName,
                })
            );
            setIsActive(response?.statusId !== POSStatus.InActive);
            setShowChangeStatusMessage(true);

            setNoSubmitReason(undefined);
            setReadyForSubmit(false);
            setPermenantDate(response);

            if (!checkIsActiveBranch) {
                setExceptionMessage(t('provideActiveBranch'));
                if (taxpayerBranches && taxpayerBranches.length > 1) {
                    setBranchErrorMessage(t('selectActiveBranch'));
                } else {
                    setBranchErrorMessage(t('branchNotActive'));
                }
            }
            setSubmitReason(response, checkIsActiveBranch);
            dispatchChangeBreadcrumb([
                {
                    key: 'currentDevice',
                    text: response?.name ?? '',
                    isCurrentItem: true,
                },
            ]);
        } catch (exp) {
            const err = UIHelpers.GetCustomErrors(exp);
            setExceptionMessage(err.message);
        }
    };

    const SaveDevice = async (reNew = false) => {
        setExceptionMessage('');

        const client = ServiceCreator.getPosManagementPublicClient();

        if (form.current.isValid) {
            setIsLoading(true);

            try {
                if (currentMode !== 'new') {
                    const obj = new EditCurrentDeviceDto();
                    obj.branchId = taxpayerBranches?.find(
                        (i) => i.branchNumber === device?.branchNumber
                    )?.branchID;
                    obj.name = device?.name;
                    obj.description = device?.description;
                    obj.activeFrom = UIHelpers.AdjustDate(device?.activeFrom);
                    obj.activeTo = UIHelpers.AdjustDate(device?.activeTo);

                    obj.status =
                        device?.statusId === POSStatus.InActive
                            ? DeviceStatusDto.InActive
                            : DeviceStatusDto.Active;
                    obj.modelId = device?.modelId;
                    obj.serialNumber = device?.serialNumber;
                    await client.editCurrentDevice(
                        Number.parseInt(id, 10) ?? 0,
                        obj
                    );

                    setShowMessageSuccess(true);
                    setTimeout(() => {
                        setShowMessageSuccess(false);
                    }, SuccessMessageDuration);

                    await getDeviceDetails();
                    setIsEditable(false);
                } else {
                    setRegisterAndNew(reNew);
                    const obj = new CurrentDeviceDto();
                    const credentialExpiryDate = new Date();
                    credentialExpiryDate.setFullYear(
                        credentialExpiryDate.getFullYear() + 1
                    );
                    obj.name = device?.name;
                    obj.modelName = device?.modelName;
                    obj.vendorName = device?.vendorName;
                    obj.branchNumber = device?.branchNumber;
                    obj.description = device?.description;
                    obj.activeFrom = UIHelpers.AdjustDate(device?.activeFrom);
                    obj.activeTo = UIHelpers.AdjustDate(device?.activeTo);
                    obj.status =
                        device?.statusId === POSStatus.Active ||
                        device?.statusId === POSStatus.Pending
                            ? DeviceStatusDto.Active
                            : DeviceStatusDto.InActive;
                    obj.serialNumber = device?.serialNumber;
                    obj.credentialExpiryDate = credentialExpiryDate;
                    const arr: CurrentDeviceDto[] = [];
                    arr.push(obj);
                    const response = await client.addDevices(arr);
                    if ((response?.rejectedDevices?.length ?? 0) > 0) {
                        const { rejectedDevices } = response;
                        if (rejectedDevices && rejectedDevices.length > 0) {
                            let err = '';
                            const errs = rejectedDevices[0].errors;
                            errs?.forEach((error) => {
                                err = `${err}, ${error.message}`;
                            });
                            err = err.substring(err.length, 1);
                            setExceptionMessage(err);
                        }
                    } else {
                        // history.push('/pos');
                        setClientSecret(
                            response?.acceptedDevices?.[0].clientSecrets
                        );
                        setDevice(
                            new TaxpayerDeviceDetailDto({
                                ...device,
                                id: response?.acceptedDevices?.[0].deviceId,
                            })
                        );
                        setShowRegenerateDialog(true);
                    }
                }
            } catch (exp) {
                const err = UIHelpers.GetCustomErrors(exp);
                setExceptionMessage(err.message);
            }
        }
        setIsLoading(false);
        setShowChangeStatusMessage(false);
    };

    const performLoadDetails = async () => {
        await getDeviceDetails();
    };

    const onRenderItem = (
        ddProps: ISelectableOption | undefined,
        df?: (renderProps: ISelectableOption | undefined) => JSX.Element | null
    ) => {
        if (isEditable && (ddProps?.key === '3' || ddProps?.key === '4'))
            return null;
        if (df && ddProps?.key) {
            return (
                <div className={`${ddProps?.data?.toString()}${'Status'}`}>
                    {df(ddProps)}
                </div>
            );
        }
        return null;
    };

    const onRenderTitle = (options: IDropdownOption[] | undefined) => {
        if (options) {
            const option = options[0];
            return (
                <div className={`${option.data?.toString()}${'Status'}`}>
                    {option?.text}
                </div>
            );
        }
        return null;
    };

    const disableStatus = (): boolean => {
        return (
            device?.statusId === POSStatus.Pending ||
            !isEditable ||
            device?.isStatusUpdatedByAdmin === true
        );
    };

    const getBranches = async () => {
        const rin = authService.currentUser?.profile.TaxRin ?? null;
        const client = CommonServiceCreator.getUserProfileAdminClient();
        const response = await client.getTaxpayerByRinLight(rin);
        return response.taxpayerBranchs;
    };

    const checkBranchErrorMessage = (
        branchesList:
            | {
                  key: string;
                  data: string | undefined;
                  text: string;
              }[]
    ): void => {
        if (!isActiveBranch) {
            if (branchesList.length > 1) {
                setBranchErrorMessage(t('selectActiveBranch'));
                return;
            }
            setBranchErrorMessage(t('branchNotActive'));
        }
    };

    const setBranches = async () => {
        let branches = propscurrentTaxpayerProfile
            ? propscurrentTaxpayerProfile.taxpayerBranchs
            : await getBranches();

        branches = branches?.filter((branch) =>
            (currentMode === 'view' &&
                device?.branchNumber !== branch.branchNumber) ||
            currentMode === 'new'
                ? UIHelpers.checkBranchActivity(
                      branch.branchStartDate,
                      branch.branchCeaseDate
                  )
                : true
        );
        setTaxpayerBranches(branches);

        const branchesList = branches?.map((item) => {
            const name =
                propsCurrentLanguage?.lang === 'en'
                    ? item.namePrimaryLang ?? item.nameSecondaryLang
                    : item.nameSecondaryLang ?? item.namePrimaryLang;
            const address =
                propsCurrentLanguage?.lang === Languages.En
                    ? item.address?.formattedAddressEn
                    : item.address?.formattedAddressAr;
            return {
                key: item.branchNumber?.toString() ?? '',
                data: address,
                text: `${item.branchNumber} | ${
                    name ?? address ?? item.sourceAddress ?? ''
                }`,
            };
        });

        switch (currentMode) {
            case 'new':
                if (branchesList && branchesList.length < 1)
                    setBranchErrorMessage(t('branchNotActive'));
                break;
            case 'view':
                if (branchesList) checkBranchErrorMessage(branchesList);
                break;
            default:
                break;
        }
        setTaxpayerBranchesList(branchesList);
    };

    useEffect(() => {
        if (inEditMode) {
            setIsEditable(true);
        }
    }, [inEditMode]);

    useEffect(() => {
        if (propsCurrentLanguage.lang !== currentLanguage?.lang) {
            setCurrentLanguage(propsCurrentLanguage);
            setExceptionMessage(undefined);
            if (currentMode && currentMode !== 'new') performLoadDetails();
        }
    }, [propsCurrentLanguage, currentLanguage]);
    useEffect(() => {
        if (currentMode) setBranches();
    }, [currentMode, currentLanguage]);

    useEffect(() => {
        const mode: DeviceDetailsType = id === 'new' ? 'new' : 'view';
        if (mode === 'new') {
            setIsEditable(true);
            dispatchChangeBreadcrumb([
                {
                    key: 'addDevice',
                    text: t('pos:addNewDevice'),
                },
            ]);
            const newDevice = new TaxpayerDeviceDetailDto({
                statusId: POSStatus.Pending,
                activeFrom: today,
            });
            setDevice(newDevice);
            setCurrentMode(mode);
        } else {
            const performLoading = async () => {
                await getDeviceDetails();
                const client = ServiceCreator.getPosManagementPublicClient();
                const config = await client.config();
                setRetiringWindow(config.retiringWindow);
                setCurrentMode(mode);
            };
            performLoading();
        }
    }, []);

    const onFormCanceled = () => {
        if (currentMode !== 'new') {
            setIsEditable(false);
            setCurrentMode('view');
            performLoadDetails();
        } else {
            history.push('/TaxpayerProfile');
        }
    };

    const onFormEdit = () => {
        setIsEditable(true);
    };

    const ChangeStatus = () => {
        setShowDeactivateDialog(false);
        const performLoading = async () => {
            await getDeviceDetails();
        };
        performLoading();
    };

    const ChangeRetireStatus = () => {
        setIsEditable(false);
        setShowRetireDialog(false);
        const performLoading = async () => {
            await getDeviceDetails();
        };
        performLoading();
    };
    const SearchModels = (
        vendorOrModelName: string | undefined,
        critieras: SearchCriteria[],
        pageIndex: number
    ) => {
        setModelErrorMessage('');

        const performSearch = async () => {
            const client = ServiceCreator.getPosManagementPublicClient();
            try {
                const result = await client.getModels(
                    undefined,
                    undefined,
                    undefined,
                    vendorOrModelName,
                    undefined,
                    undefined,
                    ModelStatus.Active,
                    VendorStatus.Active,
                    undefined,
                    undefined,
                    pageIndex + 1,
                    10
                );
                let { data } = result;
                if (currentMode === 'new')
                    data = data?.filter((i) => i.name !== predefinedModel);
                setModels(data);
                setModelMetadata({
                    totalCount: result.totalCount,
                    totalPages: result.pagesCount,
                });
            } catch (ex) {
                const err = UIHelpers.GetCustomErrors(ex);
                setModelErrorMessage(err.message);
            }
        };
        performSearch();
    };

    const onChangeBranch = (branchNumber: string) => {
        const branch = taxpayerBranches?.find(
            (item) => item.branchNumber?.toString() === branchNumber
        );

        if (branch) {
            const isBranchActive = UIHelpers.checkBranchActivity(
                branch.branchStartDate,
                branch.branchCeaseDate
            );
            setIsActiveBranch(isBranchActive);
            if (device) setSubmitReason(device, isBranchActive);
            if (isBranchActive) {
                setBranchErrorMessage('');
                setExceptionMessage('');
            }
            if (!isBranchActive) {
                setBranchErrorMessage(t('selectActiveBranch'));
                setExceptionMessage(t('provideActiveBranch'));
            }
        }
    };

    const SecretsGenerateg = () => {
        if (registerAndNew) {
            setDevice(
                new TaxpayerDeviceDetailDto({
                    statusId: POSStatus.Pending,
                    activeFrom: today,
                    branchNumber: undefined,
                })
            );
            setShowRegenerateDialog(false);
            setModelItem(undefined);
        } else if (currentMode === 'view') {
            setShowRegenerateDialog(false);
            performLoadDetails();
        } else history.push('/TaxpayerProfile');
    };
    const header = (
        <div className="panelHeader">
            {currentMode === 'new' ? (
                <Section title={t('pos:addNewDevice')} size={SectionSize.h3} />
            ) : (
                <span className="deviceTitle">{device?.name}</span>
            )}

            {currentMode !== 'new' && device?.id !== undefined && (
                <CommandBar
                    className="commands"
                    items={[]}
                    farItems={getCommandBar()}
                />
            )}
        </div>
    );
    const footer = (
        <div className="btnSaveCode">
            <DefaultButton
                className="cancelBtn"
                text={t('cancel')}
                onClick={onFormCanceled}
                iconProps={cancelIcon}
            />
            {currentMode === 'new' && (
                <DefaultButton
                    className="regAndNew"
                    text={t('pos:registerAndNew')}
                    onClick={() => SaveDevice(true)}
                    disabled={!(isFormValid && !!modelItem)}
                />
            )}
            <PrimaryButton
                className="regPos"
                text={t(currentMode === 'new' ? 'pos:RegisterPOS2' : 'save')}
                onClick={() => SaveDevice()}
                disabled={!(isFormValid && !!modelItem && isActiveBranch)}
                iconProps={currentMode === 'new' ? undefined : saveIcon}
            />
        </div>
    );

    return (
        <LayoutContent loading={isLoading} className="manageDevice">
            <div className="msgDevice">
                {(device?.statusId === POSStatus.Retiring ||
                    device?.statusId === POSStatus.Retired) && (
                    <MessageBar
                        messageBarType={MessageBarType.warning}
                        isMultiline={false}
                        truncated
                    >
                        {`${t(
                            device?.statusId === POSStatus.Retiring
                                ? 'retiringMessage'
                                : 'retiredMessage',
                            {
                                Name: device.isStatusUpdatedByAdmin
                                    ? 'ETA'
                                    : device.lastModifiedByUserId,
                                Hours: RetiringWindow,
                                Reason: device.statusReason,
                            }
                        )}`}
                    </MessageBar>
                )}
                {showMessageSuccess && (
                    <MessageBar
                        messageBarType={MessageBarType.success}
                        isMultiline={false}
                    >
                        {currentMode === 'new'
                            ? t('successSaved')
                            : t('successUpdate')}
                    </MessageBar>
                )}
                {exceptionMessage && (
                    <MessageBar
                        messageBarType={MessageBarType.error}
                        isMultiline={false}
                        onDismiss={() => {
                            setExceptionMessage(undefined);
                        }}
                        truncated
                        dismissButtonAriaLabel="Close"
                        overflowButtonAriaLabel="See more"
                    >
                        {exceptionMessage?.toString() ?? ''}
                    </MessageBar>
                )}
                {showChangeStatusMessage &&
                    device?.statusId === POSStatus.InActive &&
                    !isEditable &&
                    !isEmptyText(device?.statusReason) && (
                        <MessageBar
                            messageBarType={MessageBarType.warning}
                            isMultiline={false}
                            onDismiss={() => {
                                setShowChangeStatusMessage(false);
                            }}
                            truncated
                            dismissButtonAriaLabel="Close"
                            overflowButtonAriaLabel="See more"
                        >
                            <div>
                                <span className="bold">
                                    {t('changeDeviceStatus1')}
                                </span>
                                <span>{`${t('changeDeviceStatus2')} ${'“'} ${
                                    device?.statusReason ?? ''
                                } ${'”'}`}</span>
                            </div>
                        </MessageBar>
                    )}
            </div>
            <Panel
                title=""
                allowEdition={false}
                editable={isEditable}
                editTitle={t('edit')}
                onChangeEdit={onFormEdit}
                footer={footer}
                header={header}
            >
                <div>
                    <div className="containerManage">
                        <div
                            className={
                                isEditable ? 'bodyDevice4' : 'bodyDevice'
                            }
                        >
                            <Dropdown
                                label={t('branch')}
                                selectedKey={
                                    device?.branchNumber?.toString() ?? null
                                }
                                readOnly={!isEditable}
                                required={isEditable}
                                validationFunc={(v) =>
                                    required(t, v, t('branch'))
                                }
                                onValidationChange={(isValid) =>
                                    form.current.SetValidity(
                                        'branchCode',
                                        device?.branchNumber === 0
                                            ? true
                                            : isValid
                                    )
                                }
                                onChange={(_, option) => {
                                    setDevice(
                                        new TaxpayerDeviceDetailDto({
                                            ...device,
                                            branchNumber: Number.parseInt(
                                                option?.key.toString() ?? '0',
                                                10
                                            ),
                                            formatedAddress: option?.data,
                                        })
                                    );

                                    if (option?.key)
                                        onChangeBranch(option.key.toString());
                                }}
                                errorMessage={branchErrorMessage}
                                options={taxpayerBranchesList ?? []}
                            />

                            <TextField
                                label={t('branchAddress')}
                                readOnly
                                value={device?.formatedAddress ?? ''}
                            />
                        </div>
                        <div className="lineSeparator" />

                        <div className="bodyDevice">
                            {currentMode === 'new' ? (
                                <div className="searchComboBox_Vendor">
                                    <Label required={isEditable}>
                                        {t('modelVendor')}
                                    </Label>
                                    <SearchComboBox
                                        containerClassName="flexGrow"
                                        alignment="Left"
                                        rtl={currentLanguage?.isRtl}
                                        callOutWidth="ContentFit"
                                        errorMessage={modelErrorMessage}
                                        placeholder={t('searchModel')}
                                        paginationSetting={{
                                            nbItemPerPage: 10,
                                            nbPageShown: 5,
                                            currentPage: modelCurrentPage,
                                            totalPage:
                                                modelMetadata?.totalPages ?? 0,
                                        }}
                                        items={models}
                                        totalCount={modelMetadata?.totalCount}
                                        selectedItem={modelItem}
                                        accessKeyProp={(i: any) =>
                                            i?.id ? i?.id.toString() : '0'
                                        }
                                        accessTextProp={(i: any) => {
                                            return `${i.vendorName} | ${i.name}`;
                                        }}
                                        onChangeTextSearch={(text: string) => {
                                            return text;
                                        }}
                                        onSearch={(
                                            text: string | undefined,
                                            criterias:
                                                | SearchCriteria[]
                                                | undefined,
                                            pageIndex: number
                                        ) => {
                                            setModelCurrentPage(pageIndex);
                                            const perform = async () => {
                                                SearchModels(
                                                    text,
                                                    criterias ?? [],
                                                    pageIndex
                                                );
                                            };
                                            perform();
                                        }}
                                        onSelectItem={(
                                            item: any | undefined
                                        ) => {
                                            setModelItem(item);
                                            setDevice(
                                                new TaxpayerDeviceDetailDto({
                                                    ...device,
                                                    modeTypeName: undefined,
                                                })
                                            );
                                            if (item) {
                                                setDevice(
                                                    new TaxpayerDeviceDetailDto(
                                                        {
                                                            ...device,
                                                            modelName:
                                                                item?.name,
                                                            vendorName:
                                                                item?.vendorName,
                                                            modeTypeName:
                                                                item?.typeName,
                                                        }
                                                    )
                                                );
                                                const newList =
                                                    modelList.concat(
                                                        item || []
                                                    );
                                                setModelList(newList);
                                                setModelCurrentPage(0);
                                                form.current.SetValidity(
                                                    'modelId',
                                                    true
                                                );
                                            }
                                        }}
                                        onRenderItem={(model: any) => {
                                            return (
                                                <div className="deviceDetails_vendor_modeTiltle">
                                                    <div className="vendorName">
                                                        {model.vendorName}
                                                    </div>
                                                    <div className="modelName">
                                                        {model.name}
                                                    </div>
                                                </div>
                                            );
                                        }}
                                        OneResultBehavior="None"
                                        clearOnSelectedItem
                                    />
                                </div>
                            ) : (
                                <TextField
                                    readOnly
                                    label={t('modelVendor')}
                                    value={`${device?.vendorName} | ${device?.modelName}`}
                                />
                            )}
                            <TextField
                                readOnly
                                value={device?.modeTypeName}
                                label={t('mType')}
                            />

                            {currentMode !== 'new' && (
                                <div>
                                    <TextField
                                        readOnly
                                        label={t('credentialsExpiry')}
                                        value={UIHelpers.FormatDatePickerValue(
                                            device?.credentialExpiryDate,
                                            currentLanguage?.langIso4
                                        )}
                                    />
                                </div>
                            )}
                        </div>
                        <div
                            className={
                                currentMode === 'new'
                                    ? 'bodyDevice3'
                                    : 'bodyDevice'
                            }
                        >
                            <TextField
                                label={t('name')}
                                value={device?.name}
                                required={isEditable}
                                maxLength={200}
                                validationFunc={(v) =>
                                    required(t, v, t('name'))
                                }
                                onValidationChange={(isValid) =>
                                    form.current.SetValidity('name', isValid)
                                }
                                readOnly={!isEditable}
                                onChange={(e, val) =>
                                    setDevice(
                                        new TaxpayerDeviceDetailDto({
                                            ...device,
                                            name: val,
                                        })
                                    )
                                }
                            />
                            <TextField
                                label={t('desc')}
                                value={device?.description}
                                readOnly={!isEditable}
                                maxLength={1000}
                                onChange={(e, val) =>
                                    setDevice(
                                        new TaxpayerDeviceDetailDto({
                                            ...device,
                                            description: val,
                                        })
                                    )
                                }
                            />
                            {currentMode !== 'new' && (
                                <TextField
                                    label={t('serialNumber')}
                                    value={device?.serialNumber}
                                    required={isEditable}
                                    validationFunc={(v) =>
                                        required(t, v, t('serialNumber'))
                                    }
                                    onValidationChange={(isValid) =>
                                        form.current.SetValidity(
                                            'serialNumber',
                                            isValid
                                        )
                                    }
                                    readOnly={
                                        !(
                                            isEditable &&
                                            device?.statusId ===
                                                POSStatus.Pending
                                        )
                                    }
                                    onChange={(e, val) =>
                                        setDevice(
                                            new TaxpayerDeviceDetailDto({
                                                ...device,
                                                serialNumber: val,
                                            })
                                        )
                                    }
                                />
                            )}
                        </div>
                        <div
                            className={
                                currentMode === 'new'
                                    ? 'bodyDevice2'
                                    : 'bodyDevice'
                            }
                        >
                            <div>
                                {isEditable ? (
                                    <>
                                        <DatePicker
                                            label={t('activefrom')}
                                            disabled={
                                                isEditable &&
                                                currentMode === 'view'
                                            }
                                            value={device?.activeFrom ?? today}
                                            onSelectDate={(val) =>
                                                setDevice(
                                                    new TaxpayerDeviceDetailDto(
                                                        {
                                                            ...device,
                                                            activeFrom:
                                                                val ?? today,
                                                        }
                                                    )
                                                )
                                            }
                                            firstWeekOfYear={1}
                                            showMonthPickerAsOverlay
                                            isRequired={isEditable}
                                            allowTextInput
                                            formatDate={(date) => {
                                                return UIHelpers.FormatDatePickerValue(
                                                    date,
                                                    currentLanguage?.langIso4
                                                );
                                            }}
                                            parseDateFromString={
                                                UIHelpers.ParseDatePickerString
                                            }
                                        />
                                    </>
                                ) : (
                                    <TextField
                                        readOnly
                                        value={UIHelpers.FormatDatePickerValue(
                                            device?.activeFrom,
                                            currentLanguage?.langIso4
                                        )}
                                        label={t('activefrom')}
                                    />
                                )}
                            </div>
                            <div>
                                {isEditable ? (
                                    <>
                                        <DatePicker
                                            label={t('activeto')}
                                            value={device?.activeTo}
                                            onSelectDate={(val) =>
                                                setDevice(
                                                    new TaxpayerDeviceDetailDto(
                                                        {
                                                            ...device,
                                                            activeTo:
                                                                val ??
                                                                undefined,
                                                        }
                                                    )
                                                )
                                            }
                                            firstWeekOfYear={1}
                                            showMonthPickerAsOverlay
                                            allowTextInput
                                            minDate={device?.activeFrom}
                                            formatDate={(date) => {
                                                return UIHelpers.FormatDatePickerValue(
                                                    date,
                                                    currentLanguage?.langIso4
                                                );
                                            }}
                                            parseDateFromString={
                                                UIHelpers.ParseDatePickerString
                                            }
                                        />
                                    </>
                                ) : (
                                    <TextField
                                        readOnly
                                        value={UIHelpers.FormatDatePickerValue(
                                            device?.activeTo,
                                            currentLanguage?.langIso4
                                        )}
                                        label={t('activeto')}
                                    />
                                )}
                            </div>
                            <div>
                                <div className="reasonHeader">
                                    <Label>{t('status')}</Label>
                                </div>
                                <Dropdown
                                    onRenderItem={onRenderItem}
                                    onRenderTitle={onRenderTitle}
                                    disabled={disableStatus()}
                                    readOnly={
                                        device?.statusId ===
                                            POSStatus.Pending || !isEditable
                                    }
                                    selectedKey={device?.statusId?.toString()}
                                    onChange={(_, option) => {
                                        setDevice(
                                            new TaxpayerDeviceDetailDto({
                                                ...device,
                                                statusId: Number.parseInt(
                                                    option?.key.toString() ??
                                                        '0',
                                                    10
                                                ),
                                            })
                                        );
                                    }}
                                    options={
                                        device?.statusId === POSStatus.Pending
                                            ? DeviceStatusEnum
                                            : DeviceStatusEnum.filter(
                                                  (x) => x.key !== '0'
                                              )
                                    }
                                />
                            </div>
                            {currentMode === 'new' && (
                                <TextField
                                    label={t('serialNumber')}
                                    value={device?.serialNumber}
                                    required={
                                        currentMode === 'new' || isEditable
                                    }
                                    validationFunc={(v) =>
                                        required(t, v, t('serialNumber'))
                                    }
                                    onValidationChange={(isValid) =>
                                        form.current.SetValidity(
                                            'serialNumber',
                                            isValid
                                        )
                                    }
                                    readOnly={
                                        !(
                                            isEditable &&
                                            device?.statusId ===
                                                POSStatus.Pending
                                        )
                                    }
                                    onChange={(e, val) =>
                                        setDevice(
                                            new TaxpayerDeviceDetailDto({
                                                ...device,
                                                serialNumber: val,
                                            })
                                        )
                                    }
                                />
                            )}
                            {currentMode !== 'new' && (
                                <TextField
                                    label={t('readyToSubmit')}
                                    className={
                                        readyForSubmit
                                            ? 'canSubmit'
                                            : 'noSubmit'
                                    }
                                    readOnly
                                    value={noSubmitReason}
                                />
                            )}
                        </div>
                        <div className="bodyDevice">
                            {currentMode !== 'new' && (
                                <>
                                    <TextField
                                        readOnly
                                        label={t('first_Authentication')}
                                        value={UIHelpers.getLocalizedDateTime(
                                            'DateTime',
                                            device?.firstAuthenticationDate,
                                            currentLanguage?.langIso4,
                                            false,
                                            false
                                        )}
                                    />
                                    <TextField
                                        readOnly
                                        label={t('last_Authentication')}
                                        value={UIHelpers.getLocalizedDateTime(
                                            'DateTime',
                                            device?.lastAuthenticationDate ??
                                                device?.firstAuthenticationDate,
                                            currentLanguage?.langIso4,
                                            false,
                                            false
                                        )}
                                    />
                                    <TextField
                                        readOnly
                                        label={t('lastSent_Receipt')}
                                        value={UIHelpers.FormatDatePickerValue(
                                            device?.lastReceiptDate,
                                            currentLanguage?.langIso4
                                        )}
                                    />
                                </>
                            )}
                        </div>
                        <div className="bodyDevice">
                            {currentMode !== 'new' && (
                                <>
                                    <TextField
                                        readOnly
                                        label={t('RetirementDate')}
                                        value={UIHelpers.getLocalizedDateTime(
                                            'DateTime',
                                            device?.retiredDate,
                                            currentLanguage?.langIso4
                                        )}
                                    />
                                    <TextField
                                        readOnly
                                        className={
                                            device?.statusId ===
                                            POSStatus.Retiring
                                                ? 'permRetire'
                                                : ''
                                        }
                                        label={t('PermanentRetirementDate')}
                                        value={UIHelpers.getLocalizedDateTime(
                                            'DateTime',
                                            permDate,
                                            currentLanguage?.langIso4
                                        )}
                                    />
                                </>
                            )}
                        </div>
                    </div>
                </div>
            </Panel>
            {showDeactivateDialog && (
                <StatusDialog
                    data={device}
                    onSave={() => ChangeStatus()}
                    onClose={() => setShowDeactivateDialog(false)}
                />
            )}

            {showRetireDialog && (
                <RetireDialog
                    onClose={() => setShowRetireDialog(false)}
                    hidden={showRetireDialog}
                    onSave={() => ChangeRetireStatus()}
                    data={device}
                />
            )}
            {showRegenerateDialog && (
                <RegenerateDeviceSecrets
                    id={device?.id ?? 0}
                    newMode={currentMode === 'new'}
                    hidden={!showRegenerateDialog}
                    onClose={() => setShowRegenerateDialog(false)}
                    onSave={SecretsGenerateg}
                    currentLanguage={propsCurrentLanguage}
                    generatedSecrets={clientSecret}
                />
            )}
        </LayoutContent>
    );
};
export default connector(DeviceDetails);
